// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/crm/leads/css/note-single.css
// module id = 4700
// module chunks = 0